<app-image *ngIf="dataUrl" [url]="dataUrl"></app-image>
